import { Link } from "react-router-dom";
import BookDemoButton from "./BookDemoButton";

// End-of-home CTA band. "See pricing" routes to /pricing; "Book a demo" opens
// the Cal.com modal. No phone number or address — by design.
export default function HomeCta() {
  return (
    <section className="v3-container v3-cta">
      <h2 className="v3-cta-h">
        Let Dash
        <br />
        get it.
      </h2>
      <p className="v3-cta-sub">
        Fifteen minutes. Forwards your existing number. No hardware, no
        contracts, no minutes billed. A receptionist on the line, on call,
        today.
      </p>
      <div className="v3-cta-ctas">
        <BookDemoButton />
        <Link to="/pricing" className="dash-btn dash-btn--ghost">
          See pricing
        </Link>
      </div>
    </section>
  );
}
